export const DASHBOARD = 'Dashboard';
export const COURSES = 'Training';
export const PERSONNEL = 'Personnel';
export const EVENTS = 'Events';
export const INDUCTIONS = 'Inductions';
export const ACCIDENTS = 'Accidents';
export const MEETINGS = 'Meetings';
export const USERS = 'Users';
export const HAZARDS = 'Hazards';
export const DOCUMENT_LIBRARY = 'HasTrak Global Document Library';
export const DOCUMENT_LIBRARY_FOR_BRANCH = 'Client Document Library';

export default {
  DASHBOARD,
  COURSES,
  PERSONNEL,
  EVENTS,
  INDUCTIONS,
  ACCIDENTS,
  MEETINGS,
  USERS,
  HAZARDS,
  DOCUMENT_LIBRARY,
  DOCUMENT_LIBRARY_FOR_BRANCH
};
